import { useState, useEffect } from 'react';

export const useTimerDelay = (cb, props, delay = 500) => {
  const [timer, setTimer] = useState();

  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
    }

    setTimer(
      setTimeout(() => {
        cb();
      }, delay)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...props]);
};
